import React, { useEffect } from "react";
import "./ProfilePending.css";
import OnboardingHeader from "../../Onboarding/OnboardingHeader";
import Icons from "../../../../../Config/Images";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getLoggedInUserDetailsAPI } from "../../../../../Store/Action/UserAction";
import Header from "../../../Layout/Header/Header";
import HeaderBlack from "../../../WelcomeScreen/Common/Header";

const ProfilePending = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Get the logged-in user details to check their status
  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        const userStatus = result?.data?.[0]?.user_status_name;

        if (userStatus === "rejected") {
          // Redirect to the Profile Not Approved page if status is rejected
          navigate("/profile-not-approved", { replace: true });
        } else if (userStatus === "approved") {
          // Redirect to the Profile Verified page if status is approved
          navigate("/profile-verified", { replace: true });
        }
      })
    );
  }, [dispatch, navigate]);

  // Prevent back navigation
  useEffect(() => {
    const blockBackNavigation = () => {
      window.history.pushState(null, "", window.location.href);
    };

    blockBackNavigation();
    window.addEventListener("popstate", blockBackNavigation);

    return () => {
      window.removeEventListener("popstate", blockBackNavigation);
    };
  }, []);
  return (
    <>
      {/* <OnboardingHeader /> */}
      <div style={{ position: "sticky", top: 0 }}>
        <div className="section-1-div">
          <HeaderBlack noLoginBtn={true} />
        </div>
      </div>
      <div
        className="profile-under-review-pending"
        style={{
          backgroundImage: `url(${Icons.loginBgImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
        }}
      >
        <div className="profile-review-card-pending">
          <div className="profile-review-image">
            <img
              src={Icons.under_review_image}
              alt="Profile Under Review Image"
            />
          </div>
          <div className="profile-review-card-content">
            <h3 className="heading-profile-pending">
              Verification Still in Progress
            </h3>
            <p className="description-profile-pening">
              Your profile verification is taking longer than expected. Please
              bear with us as we ensure the accuracy and security of your
              information. This process may take a few more minutes. We
              appreciate your patience and will notify you once the review
              process is complete.
            </p>

            <button className="pending-thank-you-button" onClick={()=> navigate("/")}>Thank You</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfilePending;
